import { render, staticRenderFns } from "./MessagesHistorical.vue?vue&type=template&id=4d501ab0&"
import script from "./MessagesHistorical.vue?vue&type=script&lang=ts&"
export * from "./MessagesHistorical.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports